import { IFieldSchema } from "../interfaces/IFieldSchema";
import { Field } from "./Field";
import { FIELDARRAY } from "../utils";

/**
 * Decorator that will determine a field array on the database model
 * 
 * @param type:any
 *   The type object that should be used when building out this array
 * @param options?: IFieldSchema
 *   The options this field should use when building out the database model
 * @return Function
 *   Will return a function that will be used by the Reflection API to build out everything on the object
 */
export function FieldArray(type: any, options?: IFieldSchema) {
    return (target: any, propertyKey: string) => {
        Field(options)(target, propertyKey);
        Reflect.defineMetadata(FIELDARRAY, type, target, propertyKey);
    }
}